<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.2667 6.33024L12.8042 0.225242C12.6508 0.0805664 12.4484 0 12.2375 0H3.29998C2.84429 0 2.47498 0.369316 2.47498 0.825V21.175C2.47498 21.6307 2.84429 22 3.29998 22H18.7C19.1557 22 19.525 21.6307 19.525 21.175V6.93C19.525 6.70312 19.4315 6.48613 19.2667 6.33024ZM17.875 20.35H4.12498V1.65H11.9094L17.875 7.28557V20.35Z"  class="icon-fill"/>
    <path d="M14.8499 13.475H6.87493C6.41924 13.475 6.04993 13.8443 6.04993 14.3C6.04993 14.7557 6.41924 15.125 6.87493 15.125H14.8499C15.3056 15.125 15.6749 14.7557 15.6749 14.3C15.6749 13.8443 15.3056 13.475 14.8499 13.475Z"  class="icon-fill"/>
    <path d="M11.5499 10.175H6.87493C6.41924 10.175 6.04993 10.5443 6.04993 11C6.04993 11.4557 6.41924 11.825 6.87493 11.825H11.5499C12.0056 11.825 12.3749 11.4557 12.3749 11C12.3749 10.5443 12.0056 10.175 11.5499 10.175Z"  class="icon-fill"/>
    <path d="M14.8499 16.775H6.87493C6.41924 16.775 6.04993 17.1443 6.04993 17.6C6.04993 18.0557 6.41924 18.425 6.87493 18.425H14.8499C15.3056 18.425 15.6749 18.0557 15.6749 17.6C15.6749 17.1443 15.3056 16.775 14.8499 16.775Z"  class="icon-fill"/>
    <path d="M12.925 6.32501V0.825012H11.275V7.15001C11.275 7.6057 11.6443 7.97501 12.1 7.97501H18.7V6.32501H12.925Z"  class="icon-fill"/>
  </svg>

</template>

<script>
export default {
  name: 'accessories'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>